import { Suspense, ReactNode, useTransition } from "react";
import { PageLoadingIndicator } from "./PageLoadingIndicator";

interface RouteTransitionProps {
  children: ReactNode;
  fallback?: ReactNode;
}

/**
 * RouteTransition wrapper component that provides smooth transitions between routes
 * by keeping the layout visible while page content loads.
 *
 * This component wraps lazy-loaded page components to prevent full-screen flicker
 * when navigating between routes. It uses React 18's Suspense with a minimal
 * loading indicator that only affects the content area, not the entire layout.
 */
export function RouteTransition({ children, fallback }: RouteTransitionProps) {
  return (
    <Suspense fallback={fallback || <PageLoadingIndicator />}>
      {children}
    </Suspense>
  );
}
